import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

export class EmailPrefGetter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ...props.emailPreferences
    };
  }

  updateReceiveCompanyUpdates = event => {
    this.setState({
      receiveCompanyUpdates: event.target.checked
    });
  }

  updateReceiveBetaSuggestions = event => {
    this.setState({
      receiveBetaSuggestions: event.target.checked
    });
  }

  updateReceiveBookActivityUpdates = event => {
    this.setState({
      receiveBookActivityUpdates: event.target.checked
    });
  }

  updateReceiveMessageUpdates = event => {
    this.setState({
      receiveMessageUpdates: event.target.checked
    });
  }

  submit = () => {
    const {
      receiveCompanyUpdates,
      receiveBetaSuggestions,
      receiveBookActivityUpdates,
      receiveMessageUpdates
    } = this.state;
    if (this.props.onUpdate) {
      this.props.onUpdate({
        emailPreferences: {
          receiveCompanyUpdates: !!receiveCompanyUpdates,
          receiveBetaSuggestions: !!receiveBetaSuggestions,
          receiveBookActivityUpdates: !!receiveBookActivityUpdates,
          receiveMessageUpdates: !!receiveMessageUpdates
        }
      });
    }
  }

  // render
  render() {
    const { t, updating } = this.props;
    const {
      receiveCompanyUpdates,
      receiveBetaSuggestions,
      receiveBookActivityUpdates,
      receiveMessageUpdates
    } = this.state;
    const choices = [
      ['ReceiveCompanyUpdates', receiveCompanyUpdates, this.updateReceiveCompanyUpdates],
      ['ReceiveBookEmails', receiveBetaSuggestions, this.updateReceiveBetaSuggestions],
      ['ReceiveBookActivityUpdates', receiveBookActivityUpdates, this.updateReceiveBookActivityUpdates],
      ['ReceiveMessageUpdates', receiveMessageUpdates, this.updateReceiveMessageUpdates],
    ];
    return (
      <div>
        <h2>{t('WhenDoYouWantToHearFromUs')}</h2>
        <div style={{display: 'grid', gap: 12}}>
          {choices.map(([label, checked, onChange]) => (
            <label key={label} style={{display: 'flex', alignItems: 'center', gap: 8}}>
              <input type='checkbox' checked={!!checked} onChange={onChange}
                disabled={updating} />
              <span>{t(label)}</span>
            </label>
          ))}
        </div>
        <Button style={{marginTop: '1em'}} onClick={this.submit}
          disabled={updating} aria-busy={updating}>
          {t('Next')}
        </Button>
      </div>
    );
  }
}

export default withTranslation()(EmailPrefGetter);
